module.exports = __webpack_public_path__ + "img/play.e166a8ac.svg";